exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-33f31c08] .el-tabs__item.is-active{color:#ec1c1c}[data-v-33f31c08] .el-tabs__active-bar{background-color:#ec1c1c}[data-v-33f31c08] .el-tabs__item:hover{color:#ec1c1c}[data-v-33f31c08] .el-tabs__nav{-webkit-transform:translateX(20px)!important;transform:translateX(20px)!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/opt/nodeapps/svndata/jzq-web/assets","/static":"/opt/nodeapps/svndata/jzq-web/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-33f31c08","scoped":true,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./pages/tpl/costStatistics.vue
// module id = pK/T
// module chunks = 5